import { LabelValueList } from '~/@mid_ui/label-value/LabelValueList'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { getPersonalInfoItems } from './persontalInfoItems'
import { useUser } from '~/@biz_account/useUser/useUser'
import { useCountryName } from '~/@mid_settings/countries/useCountryName'

function PersonalInfo() {
  const { user } = useUser()
  const { getCountryName } = useCountryName()

  const persontalInfoItems = getPersonalInfoItems(
    user?.profile,
    getCountryName(user?.profile.address?.state ?? '')
  )

  return (
    <div className="flex flex-col">
      <div className="flex flex-col last:grow w-full pt-10 pb-15 border-t">
        <PageContainer className="flex flex-col gap-10 md:pl-40 md:pr-15">
          <HeadingThree>Osobné údaje</HeadingThree>

          <LabelValueList
            items={persontalInfoItems}
            itemClassName="flex flex-col lg:flex-row lg:gap-3 justify-start"
          />
        </PageContainer>
      </div>
    </div>
  )
}

export { PersonalInfo }
